  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
//import Checkbox                                            from '@material-ui/core/Checkbox';
//import Radio                                               from '@material-ui/core/Radio';
//import RadioGroup                                          from '@material-ui/core/RadioGroup';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
//import FormControl                                         from '@material-ui/core/FormControl';
//import Select                                              from '@material-ui/core/Select';
//import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //[POPOVER]
//import Popover                                             from '@material-ui/core/Popover';
//import IconButton                                          from '@material-ui/core/IconButton';
//import InputAdornment                                      from '@material-ui/core/InputAdornment';
//import Typography                                          from '@material-ui/core/Typography';
//import InfoIcon                                            from '@material-ui/icons/Info';
  //-------------------
  // @material-ui/icons
  //-------------------
//import CardTravel                                          from "@material-ui/icons/CardTravel";
//import Extension                                           from "@material-ui/icons/Extension";
//import Fingerprint                                         from "@material-ui/icons/Fingerprint";
//import FlightLand                                          from "@material-ui/icons/FlightLand";
//import Build                                               from "@material-ui/icons/Build";
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //----------
  // Libraries
  //----------
//import TagManager                                          from 'react-gtm-module'
//import ReCAPTCHA                                           from "react-google-invisible-recaptcha";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CountriesStatesCitiesService }                 from "../../_services";
//import { wu_IdentityCardsService }                         from "../../_services";
//import { wu_TransactionFlow }                              from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
//import { wu_GeolocationService }                           from "../../_services";
//import { wu_RegisterGOVService }                           from "../../_services";
//import { wu_RegisterIdBoxService }                         from "../../_services";
  //------
  // Style
  //------
  import RegisterIdBoxSuccessStyle                      from "./RegisterIdBoxSuccessStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
//import img2                                                from "assets/img/wu/testImg2.png";
  import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  import imgSuccess                                          from "assets/img/wu/success_payment_1.png";
  import imgFailure                                          from "assets/img/wu/failure_payment_1.png";
  //----------
  // variables
  //----------
  const filename = "RegisterIdBoxSuccess ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  // //[flagsimages]
  // var images = null;

class RegisterIdBoxSuccess extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      //[HONEYMOON]
      textField0                                           : "", //4279034659
      textField0_hasError                                  : false,

      parserObject_getCountries                            : [],
      parserObject_getCountries4Picker                     : [],

      btn_gotoTransfer_isHidden                            : true,
      btn_startAgain_isHidden                              : true,

      RegisterIdBoxSuccess_viewInfo_lbl_lbl1               : "", //GOV info
      RegisterIdBoxSuccess_viewInfo_lbl_lbl2               : "", //GOV info
      imgSuccess_isHidden                                  : true,
      imgFailure_isHidden                                  : true,

      idBoxFlow                                            : "WorldBridgeNoVideo",

      componentWillMount_withDelay_finished                : false,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                 = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                = this.dialog_handleClose.bind(this);
    this.startSpinners                                     = this.startSpinners.bind(this);
    this.stopSpinners                                      = this.stopSpinners.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                              = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                             = this.dialog200_handleClose.bind(this);

    //[goBack]
    this.goBack                                            = this.goBack.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                     = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                    = this.Snackbar_textField_handleClose.bind(this);

    this.btn_gotoTransfer_act                              = this.btn_gotoTransfer_act.bind(this);
    this.btn_gotoTransfer_act_isDisabled                   = this.btn_gotoTransfer_act_isDisabled.bind(this);

    this.btn_startAgain_act                                = this.btn_startAgain_act.bind(this);
    this.btn_startAgain_act_isDisabled                     = this.btn_startAgain_act_isDisabled.bind(this);

    this.handleSubmit_with_recaptcha                       = this.handleSubmit_with_recaptcha.bind(this);
    this.recaptchaRef                                      = React.createRef();

    this.buttons_show_hide                                 = this.buttons_show_hide.bind(this);

    this.componentWillMount_withDelay                      = this.componentWillMount_withDelay.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view")); if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    localStorage.setItem("curr_view", filename);                          if(api.print_logs){console.log(methName+localStorage.getItem("curr_view"));}

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        //++++++++++++
        //Login Screen
        //++++++++++++
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }

    // //[flagsimages]
    // images = this.importAll(require.context('assets/img/flagspng/', false, /\.(png|svg)$/));
    // //if(api.print_logs){console.log("images.length="+images.length);}
    // //for (var key in images) { if(api.print_logs){console.log("key="+key);} }

    //this.startSpinners();
    //------------
    //getCountries---CACHED
    //------------
    let retrieveWSData_getCountries = wu_CountriesStatesCitiesService.wu_should_getCountries();
    if(retrieveWSData_getCountries){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CountriesStatesCitiesService
      .wu_getCountries({})
      .then(res => {
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let parserObject_getCountries4Picker = [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      })
      .catch(err => {
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_countries({});
        var parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
      });
    }
    else{
      try{
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let res = JSON.parse(localStorage.getItem("countries"));
        var parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      }catch(err){
        console.log('err='+err);
      }
    }

    setTimeout(function() {
      this.componentWillMount_withDelay();
    }.bind(this), 45000);
    // if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
    // //-------------------
    // //wu_validatecustomer
    // //-------------------
    // wu_ProfileService
    // .wu_validatecustomer({})
    // .then(res => {
    //   this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
    //   localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));
    //
    //   let parserObject_validatecustomer = {};
    //   try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
    //   var idVerificationStatus = 0;
    //   try {idVerificationStatus = parserObject_validatecustomer["idVerificationStatus"]; }catch(err){;} if(idVerificationStatus === null){idVerificationStatus = 0; }
    //
    //   //nailed for testing:START---inactive
    //   //idVerificationStatus = 1;
    //   //nailed for testing:END
    //   let btn_startAgain_isHidden   = true;
    //   let btn_gotoTransfer_isHidden = true;
    //   let imgSuccess_isHidden       = true;
    //   let imgFailure_isHidden       = true;
    //   let aText1                    = "";
    //   let aText2                    = "";
    //   if(idVerificationStatus===1){
    //     btn_startAgain_isHidden   = true;
    //     btn_gotoTransfer_isHidden = false;
    //     imgSuccess_isHidden       = false;
    //     imgFailure_isHidden       = true;
    //     aText1 = this.NSInforString("RegisterIdBoxSuccess_viewInfo_lbl_lbl1_OK");
    //     aText2 = this.NSInforString("RegisterIdBoxSuccess_viewInfo_lbl_lbl2_OK");
    //   }
    //   else{
    //     btn_startAgain_isHidden   = false;
    //     btn_gotoTransfer_isHidden = true;
    //     imgSuccess_isHidden       = true;
    //     imgFailure_isHidden       = false;
    //     aText1 = this.NSInforString("RegisterIdBoxSuccess_viewInfo_lbl_lbl1_NOK");
    //     aText2 = "";
    //   }
    //
    //   this.setState({
    //     btn_startAgain_isHidden                     : btn_startAgain_isHidden,
    //     btn_gotoTransfer_isHidden                   : btn_gotoTransfer_isHidden,
    //     imgSuccess_isHidden                         : imgSuccess_isHidden,
    //     imgFailure_isHidden                         : imgFailure_isHidden,
    //     RegisterIdBoxSuccess_viewInfo_lbl_lbl1 : aText1,
    //     RegisterIdBoxSuccess_viewInfo_lbl_lbl2 : aText2,
    //   });
    // })
    // .catch(err => {
    //   this.stopSpinners();
    //   console.log(methName+"err="+JSON.stringify(err));
    //   if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
    //   else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    // });
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount_withDelay() {
    let methName = filename+"componentWillMount_withDelay ";
    if(api.print_logs){console.log(methName);}

    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
    //-------------------
    //wu_validatecustomer
    //-------------------
    wu_ProfileService
    .wu_validatecustomer({})
    .then(res => {
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      var idVerificationStatus = 0;
      try {idVerificationStatus = parserObject_validatecustomer["idVerificationStatus"]; }catch(err){;} if(idVerificationStatus === null){idVerificationStatus = 0; }

      //nailed for testing:START---inactive
      //idVerificationStatus = 1;
      //nailed for testing:END
      let btn_startAgain_isHidden   = true;
      let btn_gotoTransfer_isHidden = true;
      let imgSuccess_isHidden       = true;
      let imgFailure_isHidden       = true;
      let aText1                    = "";
      let aText2                    = "";
      if(idVerificationStatus===1){
        btn_startAgain_isHidden   = true;
        btn_gotoTransfer_isHidden = false;
        imgSuccess_isHidden       = false;
        imgFailure_isHidden       = true;
        aText1 = this.NSInforString("RegisterIdBoxSuccess_viewInfo_lbl_lbl1_OK");
        aText2 = this.NSInforString("RegisterIdBoxSuccess_viewInfo_lbl_lbl2_OK");
      }
      else{
        btn_startAgain_isHidden   = false;
        btn_gotoTransfer_isHidden = true;
        imgSuccess_isHidden       = true;
        imgFailure_isHidden       = false;
        aText1 = this.NSInforString("RegisterIdBoxSuccess_viewInfo_lbl_lbl1_NOK");
        aText2 = "";
      }

      this.setState({
        btn_startAgain_isHidden                     : btn_startAgain_isHidden,
        btn_gotoTransfer_isHidden                   : btn_gotoTransfer_isHidden,
        imgSuccess_isHidden                         : imgSuccess_isHidden,
        imgFailure_isHidden                         : imgFailure_isHidden,
        RegisterIdBoxSuccess_viewInfo_lbl_lbl1      : aText1,
        RegisterIdBoxSuccess_viewInfo_lbl_lbl2      : aText2,

        componentWillMount_withDelay_finished       : true,
      });
    })
    .catch(err => {
      this.stopSpinners();
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    let parserObject_validatecustomer = {};
    try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
    var idVerificationStatus = 0;
    try {idVerificationStatus = parserObject_validatecustomer["idVerificationStatus"]; }catch(err){;} if(idVerificationStatus === null){idVerificationStatus = 0; }
    //nailed for testing:START---inactive
    //idVerificationStatus = 1;
    //nailed for testing:END
    let aText1                    = "";
    let aText2                    = "";
    if(idVerificationStatus===1){
      aText1 = this.NSInforString("RegisterIdBoxSuccess_viewInfo_lbl_lbl1_OK");
      aText2 = this.NSInforString("RegisterIdBoxSuccess_viewInfo_lbl_lbl2_OK");
    }
    else{
      aText1 = this.NSInforString("RegisterIdBoxSuccess_viewInfo_lbl_lbl1_NOK");
      aText2 = "";
    }
    if(this.state.componentWillMount_withDelay_finished===false){
      aText1 = this.NSInforString("RegisterLightIdBoxSuccess_msg_please_wait");
      aText2 = "";
    }

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            {api.backButtonAtHeader === true ? (
              <GridContainer justify="center">
                <GridItem xs={2} sm={2} md={1}>
                  <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                    {/* ----------[goBack]------------ */}
                    <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button>
                  </div>
                </GridItem>
                <GridItem xs={10} sm={10} md={11}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("RegisterIdBoxSuccess_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("RegisterIdBoxSuccess_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            )}

            <div>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 10 }}></div>
                  <div className={classes.label1} style={{"textAlign":"center" }}>{aText1}</div>
                  <div style={{ marginTop: 10 }}></div>
                  <div className={classes.label1} style={{"textAlign":"center" }}>{aText2}</div>
                  <div style={{ marginTop: 10 }}></div>
                  {this.state.imgSuccess_isHidden === true ? ( "" ) : (
                    <div className={classes.imgSuccess}><img width="80px" height="80px" src={imgSuccess} alt="" /></div>
                  )}
                  {this.state.imgFailure_isHidden === true ? ( "" ) : (
                    <div className={classes.imgFailure}><img width="80px" height="80px" src={imgFailure} alt="" /></div>
                  )}
                </GridItem>
              </GridContainer>

              <GridContainer justify="center">
                {/* ------------------------- */}
                {/* ----------[HONEYMOON]---- */}
                {/* ------------------------- */}
                <GridItem xs={12} sm={12} md={12} className={classes.GridItemTextField0}>
                    <TextField
                      fullWidth
                      autoComplete={this.autoCompleteText_Textfields()}
                      error={this.state.textField0_hasError}
                      className={classes.textField0}
                      id={this.autoCompleteText_Textfields()}
                      label={this.autoCompleteText_Textfields()}
                      value={this.state.textField0}
                      InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField0"), type: "text" }}
                    />
                </GridItem>
              </GridContainer>
            </div>
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <div>
              {this.state.btn_gotoTransfer_isHidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    {/* <div className={classes.labelHeader}>&nbsp;</div> */}
                    <div className={classes.textCenter}>
                      {/* <ReCAPTCHA
                        ref={ ref => this.recaptchaRef = ref }
                        locale={localStorage.getItem("lang")}
                        sitekey={api.captchKey}
                        onResolved={ this.btn_gotoTransfer_act } /> */}
                      <CustomButton
                        disabled={this.btn_gotoTransfer_act_isDisabled()}
                        className={classes.yellowButton}
                        color="rose"
                        onClick={this.btn_gotoTransfer_act}
                        type="submit">
                        {this.NSInforString("RegisterIdBoxSuccess_btn_gotoTransfer") }
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              )}
              {this.state.btn_startAgain_isHidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    {/* <div className={classes.labelHeader}>&nbsp;</div> */}
                    <div className={classes.textCenter}>
                      {/* <ReCAPTCHA
                        ref={ ref => this.recaptchaRef = ref }
                        locale={localStorage.getItem("lang")}
                        sitekey={api.captchKey}
                        onResolved={ this.btn_startAgain_act } /> */}
                      <CustomButton
                        disabled={this.btn_startAgain_act_isDisabled()}
                        className={classes.yellowButton}
                        color="rose"
                        onClick={this.btn_startAgain_act}
                        type="submit">
                        {this.NSInforString("RegisterIdBoxSuccess_btn_startAgain") }
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              )}
              {/* -------------------------------------------------- */}
              {/* ----------[goBack Bottom]------------------------- */}
              {/* -------------------------------------------------- */}
              {/* {api.backButtonAtBottom === true ? (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    <div className={classes.textCenter}>
                      <CustomButton
                        disabled={false}
                        className={classes.backButton}
                        color="rose"
                        onClick={this.goBack}>
                        {this.NSInforString("RegisterIdBoxSuccess_btn_prev")}
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              ) : ( "" ) } */}
            </div>

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------CheckBox Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------RadioButton Listeners-----------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  handleSubmit_with_recaptcha(event) {
    let methName = filename+"handleSubmit_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.idIssuingCountry_text.trim() === "")   { this.setState({"idIssuingCountry_hasError" : true }); emptyFields = true; }
      if(this.state.idType_id === "")                      { this.setState({"idType_hasError" : true }); emptyFields = true; }
      if(this.state.idNumber.trim() === "")                { this.setState({"idNumber_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){console.log("emptyFields===true");if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.btn_gotoTransfer_act_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef.reset();   }
    else                                      { console.log(methName+"execute");this.recaptchaRef.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_gotoTransfer_act_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_gotoTransfer_act(event) {
    let methName = filename+"btn_gotoTransfer_act ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(emptyFields===true){console.log("emptyFields===true");if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    //event.preventDefault();
    //+++++++++++++++
    //Goto Controller
    //+++++++++++++++
    localStorage.setItem(filename.trim(), "");//Do nothing if---set
    history.push(wu_Utilities.getNavigationURLs("TransferOnline1")); //==> RegisterIdBoxSuccess
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_startAgain_act_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_startAgain_act(event) {
    let methName = filename+"btn_startAgain_act ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(emptyFields===true){console.log("emptyFields===true");if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    //event.preventDefault();
    //+++++++++++++++
    //Goto Controller
    //+++++++++++++++
    localStorage.setItem(filename.trim(), "");//Do nothing if---set
    history.push(wu_Utilities.getNavigationURLs("RegisterLight2"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------makeHTTPConn--------------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
      this.setState({"textField0":eventTMP.trim(),});
    }
    else{
      this.setState({ [stateVar] : eventTMP });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  // importAll(r) {
  //   //return r.keys().map(r);
  //   let images = {};
  //   r.keys().map((item, index) => {
  //     images[item.replace('./', '')] = r(item);
  //     return "";
  //   });
  //   return images;
  // }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"RG3"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Specific------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  buttons_show_hide() {
    let methName = filename+"buttons_show_hide ";
    if(api.print_logs){console.log(methName);}

    this.setState({
      btn_gotoTransfer_isHidden : false,
    });
  }
  //----------------------------------------------------------------------------------------------------
}
RegisterIdBoxSuccess.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(RegisterIdBoxSuccessStyle)(RegisterIdBoxSuccess)
);
